export const commonContextEn = {
  taskLinkCopied: 'Task link copied',
  taskLinkCopy: 'Copy task link',
  starHint:
    'Make this task starred for yourself. ' +
    'To see all starred tasks go to “My tasks” » “Starred”'
}

export const commonContextRu = {
  taskLinkCopied: 'Скопирована ссылка на задачу',
  taskLinkCopy: 'Скопировать ссылку на задачу',
  starHint:
    'Пометить задачу звёздочкой для себя (коллегам не видно). ' +
    'Посмотреть все задачи со звёздочкой можно в “Мои задачи” » “Избранные”'
}

export const commonCrmContextEn = {
  taskLinkCopied: 'Deal link copied',
  taskLinkCopy: 'Copy deal link',
  starHint: 'Make this deal starred for yourself.'
}

export const commonCrmContextRu = {
  taskLinkCopied: 'Скопирована ссылка на сделку',
  taskLinkCopy: 'Скопировать ссылку на сделку',
  starHint: 'Пометить сделку звёздочкой для себя (коллегам не видно).'
}
